var map = {
	"./applied1.jpg": 2552,
	"./applied2.jpg": 5399,
	"./gcse_foundation_studentbook1.jpg": 6506,
	"./gcse_foundation_studentbook2.jpg": 6405,
	"./gcse_higher_studentbook1.jpg": 6748,
	"./gcse_higher_studentbook2.jpg": 3195,
	"./james_dyke.jpg": 4414,
	"./james_dyke_adv.jpg": 8952,
	"./pure1.jpg": 7869,
	"./pure2.jpg": 1938,
	"./stroud_booth.jpg": 5778,
	"./stroud_booth_adv.jpg": 1764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;